<template>
    <span>{{numVotes}}</span>
</template>
<script>
export default {
    props: {
        pid: {
            type: [String, Number],
            required: true,
            default: null
        }
    },

    data() {
        return {
            numVotes: 0
        }
    },

    created() {
        new Form({
            pid: this.pid
        })
        .post('/api/productratings/num-votes')
        .then((response) => {
            if(response.success) {
                this.numVotes = response.numVotes;
            }
        });

        App.event.listen('product.rating.update.num', (numVotes) => {
            this.numVotes = numVotes;      
        });
    },
}
</script>
